import { createElement } from "react";
import s from "./guide.module.css";
import { Widget } from "./Widgets";

const ALLOWED = new Set(["p", "h1", "h2", "h3", "strong", "br", "a", "ol", "ul", "li", "div", "details", "summary", "article", "hr", "dl", "dt", "dd"]);

const slug = (t) => t.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "").slice(0, 40);
const firstText = (n) => (typeof n === "string" ? n : (n.k || []).map(firstText).join(""));

// Renders the editorial block tree (wua-sci-student/1): whitelisted tags + role classes, text only (no HTML injection).
export function renderNode(n, ctx, key) {
  if (typeof n === "string") return n;
  if (n.w) return createElement(Widget, { key, n, ctx });
  if (!ALLOWED.has(n.t)) return null;
  const props = { key, className: (n.r || []).map((r) => s[r]).filter(Boolean).join(" ") || undefined };
  if (n.t === "a") Object.assign(props, { href: n.href, target: "_blank", rel: "noopener noreferrer" });
  if (n.t === "h1" || n.t === "h2") props.className = [props.className, "font-editorial"].filter(Boolean).join(" ");
  if (n.t === "details") {
    const sum = (n.k || []).find((c) => c.t === "summary");
    if (sum) props["data-testid"] = `student-details-${slug(firstText(sum))}`;
  }
  if (n.t === "br" || n.t === "hr") return createElement(n.t, props);
  const kids = (n.k || []).map((c, i) => renderNode(c, ctx, i));
  // The approved opening stays as written; a small subject label inside the H1 makes the subject unambiguous.
  if (n.t === "h1" && ctx.kicker) kids.unshift(createElement("span", { key: "kicker", className: s.kicker, "data-testid": "student-h1-kicker" }, ctx.kicker), " ");
  return createElement(n.t, props, ...kids);
}

export const renderBlocks = (items, ctx) => items.map((c, i) => renderNode(c, ctx, i));
